'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ArrowLeft, ChevronRight, ExternalLink, ShoppingCart, ArrowRight, CheckCircle2, Clock, Send, Package, XCircle, MapPin } from 'lucide-react';
import StatusBadge from '@/components/ui/StatusBadge';
import { toast } from 'sonner';

// ─── Data ─────────────────────────────────────────────────────────────────────

const allPOs = [
  { id: 'po-2854', poNumber: 'PO-2854', jobId: 'JOB-CRM-9924', jobRef: 'job-crm-9924', jobName: 'Merch drop — TechConf 2026', deliveryRef: 'DEL-9924-04', supplier: 'HydroFlask Trade', createdDate: '16/08/2026', total: '£11,000', totalRaw: 11000, status: 'draft', linkedSo: 'SO-3244', linkedSoId: 'so-3244', linkedInvoice: '—' },
  { id: 'po-2853', poNumber: 'PO-2853', jobId: 'JOB-CRM-9924', jobRef: 'job-crm-9924', jobName: 'Merch drop — TechConf 2026', deliveryRef: 'DEL-9924-03', supplier: 'PrintFast UK', createdDate: '15/08/2026', total: '£6,800', totalRaw: 6800, status: 'received', linkedSo: 'SO-3243', linkedSoId: 'so-3243', linkedInvoice: 'INV-10479' },
  { id: 'po-2852', poNumber: 'PO-2852', jobId: 'JOB-CRM-9924', jobRef: 'job-crm-9924', jobName: 'Merch drop — TechConf 2026', deliveryRef: 'DEL-9924-02', supplier: 'EcoPromo Supplies', createdDate: '15/08/2026', total: '£8,200', totalRaw: 8200, status: 'sent', linkedSo: 'SO-3242', linkedSoId: 'so-3242', linkedInvoice: '—' },
  { id: 'po-2851', poNumber: 'PO-2851', jobId: 'JOB-CRM-9924', jobRef: 'job-crm-9924', jobName: 'Merch drop — TechConf 2026', deliveryRef: 'DEL-9924-01', supplier: 'Gildan Activewear EU', createdDate: '15/08/2026', total: '£12,400', totalRaw: 12400, status: 'acknowledged', linkedSo: 'SO-3241', linkedSoId: 'so-3241', linkedInvoice: '—' },
  { id: 'po-2848', poNumber: 'PO-2848', jobId: 'JOB-CRM-9921', jobRef: 'job-crm-9921', jobName: 'Branded hoodies — RetailCo Q3', deliveryRef: 'DEL-9921-02', supplier: 'Gildan Activewear EU', createdDate: '13/08/2026', total: '£9,600', totalRaw: 9600, status: 'sent', linkedSo: 'SO-3239', linkedSoId: 'so-3239', linkedInvoice: '—' },
  { id: 'po-2847', poNumber: 'PO-2847', jobId: 'JOB-CRM-9921', jobRef: 'job-crm-9921', jobName: 'Branded hoodies — RetailCo Q3', deliveryRef: 'DEL-9921-01', supplier: 'Gildan Activewear EU', createdDate: '13/08/2026', total: '£13,200', totalRaw: 13200, status: 'acknowledged', linkedSo: 'SO-3238', linkedSoId: 'so-3238', linkedInvoice: '—' },
  { id: 'po-2843', poNumber: 'PO-2843', jobId: 'JOB-CRM-9919', jobRef: 'job-crm-9919', jobName: 'Promo kit — SaaS Summit', deliveryRef: 'DEL-9919-01', supplier: 'Moleskine Trade', createdDate: '11/08/2026', total: '£9,400', totalRaw: 9400, status: 'acknowledged', linkedSo: 'SO-3231', linkedSoId: 'so-3231', linkedInvoice: '—' },
  { id: 'po-2842', poNumber: 'PO-2842', jobId: 'JOB-CRM-9919', jobRef: 'job-crm-9919', jobName: 'Promo kit — SaaS Summit', deliveryRef: 'DEL-9919-02', supplier: 'PrintFast UK', createdDate: '11/08/2026', total: '£7,200', totalRaw: 7200, status: 'sent', linkedSo: 'SO-3232', linkedSoId: 'so-3232', linkedInvoice: '—' },
  { id: 'po-2838', poNumber: 'PO-2838', jobId: 'JOB-CRM-9917', jobRef: 'job-crm-9917', jobName: 'Tote bags — GreenFest', deliveryRef: 'DEL-9917-01', supplier: 'EcoPromo Supplies', createdDate: '08/08/2026', total: '£4,800', totalRaw: 4800, status: 'received', linkedSo: 'SO-3225', linkedSoId: 'so-3225', linkedInvoice: 'INV-10478' },
  { id: 'po-2835', poNumber: 'PO-2835', jobId: 'JOB-CRM-9915', jobRef: 'job-crm-9915', jobName: 'Embroidered polos — HealthOrg', deliveryRef: 'DEL-9915-01', supplier: 'Gildan Activewear EU', createdDate: '05/08/2026', total: '£14,200', totalRaw: 14200, status: 'closed', linkedSo: 'SO-3218', linkedSoId: 'so-3218', linkedInvoice: 'INV-10475' },
  { id: 'po-2831', poNumber: 'PO-2831', jobId: 'JOB-CRM-9912', jobRef: 'job-crm-9912', jobName: 'Caps and beanies — SportsBrand', deliveryRef: 'DEL-9912-01', supplier: 'Headwear Direct', createdDate: '01/08/2026', total: '£7,800', totalRaw: 7800, status: 'closed', linkedSo: 'SO-3211', linkedSoId: 'so-3211', linkedInvoice: 'INV-10471' },
];

const poLineItems: Record<string, { id: string; description: string; qty: number; unitCost: string; total: string }[]> = {
  'po-2854': [
    { id: 'li-2854-1', description: 'Insulated water bottle 500ml — laser engraved logo', qty: 100, unitCost: '£62.00', total: '£6,200' },
    { id: 'li-2854-2', description: 'Insulated water bottle 750ml — laser engraved logo', qty: 100, unitCost: '£48.00', total: '£4,800' },
  ],
  'po-2851': [
    { id: 'li-2851-1', description: 'Gildan 18500 hoodie — embroidered front logo — S', qty: 50, unitCost: '£24.80', total: '£1,240' },
    { id: 'li-2851-2', description: 'Gildan 18500 hoodie — embroidered front logo — M', qty: 80, unitCost: '£24.80', total: '£1,984' },
    { id: 'li-2851-3', description: 'Gildan 18500 hoodie — embroidered front logo — L', qty: 80, unitCost: '£24.80', total: '£1,984' },
    { id: 'li-2851-4', description: 'Gildan 18500 hoodie — embroidered front logo — XL', qty: 40, unitCost: '£26.80', total: '£1,072' },
    { id: 'li-2851-5', description: 'Embroidery setup charge — digitising fee', qty: 1, unitCost: '£120.00', total: '£120' },
  ],
  'po-2847': [
    { id: 'li-2847-1', description: 'Gildan 18500 hoodie navy — embroidered logo — M', qty: 60, unitCost: '£24.80', total: '£1,488' },
    { id: 'li-2847-2', description: 'Gildan 18500 hoodie navy — embroidered logo — L', qty: 60, unitCost: '£24.80', total: '£1,488' },
    { id: 'li-2847-3', description: 'Gildan 18500 hoodie navy — embroidered logo — XL', qty: 30, unitCost: '£26.80', total: '£804' },
    { id: 'li-2847-4', description: 'Embroidery setup charge', qty: 1, unitCost: '£120.00', total: '£120' },
  ],
  'po-2835': [
    { id: 'li-2835-1', description: 'Gildan 64000 polo — embroidered NHS trust logo — S', qty: 120, unitCost: '£18.40', total: '£2,208' },
    { id: 'li-2835-2', description: 'Gildan 64000 polo — embroidered NHS trust logo — M', qty: 180, unitCost: '£18.40', total: '£3,312' },
    { id: 'li-2835-3', description: 'Gildan 64000 polo — embroidered NHS trust logo — L', qty: 150, unitCost: '£18.40', total: '£2,760' },
    { id: 'li-2835-4', description: 'Embroidery setup — 5 trust variants', qty: 5, unitCost: '£120.00', total: '£600' },
    { id: 'li-2835-5', description: 'Packing and labelling per NHS spec', qty: 1, unitCost: '£320.00', total: '£320' },
  ],
};

const defaultLineItems = [
  { id: 'li-default-1', description: 'Branded merchandise — as per delivery spec', qty: 1, unitCost: '—', total: '—' },
];

// ─── Delivery address keyed by PO ID (1 per PO) ───────────────────────────────

interface DeliveryAddress {
  id: string;
  label: string;
  recipient: string;
  line1: string;
  line2?: string;
  city: string;
  postcode: string;
  country: string;
  notes?: string;
}

const deliveryAddressByPo: Record<string, DeliveryAddress> = {
  'po-2854': { id: 'da-2854', label: 'Main venue', recipient: 'TechConf Events Ltd — Goods In', line1: 'ExCeL London, One Western Gateway', city: 'London', postcode: 'E16 1XL', country: 'UK', notes: 'Deliver to loading bay B, Mon–Fri 08:00–16:00' },
  'po-2853': { id: 'da-2853', label: 'Conference centre', recipient: 'TechConf Events Ltd — Receiving', line1: 'ExCeL London, One Western Gateway', city: 'London', postcode: 'E16 1XL', country: 'UK', notes: 'Attn: Logistics Manager — ref PO-2853' },
  'po-2852': { id: 'da-2852', label: 'Primary delivery', recipient: 'TechConf Events Ltd', line1: 'ExCeL London, One Western Gateway', city: 'London', postcode: 'E16 1XL', country: 'UK' },
  'po-2851': { id: 'da-2851', label: 'Main venue', recipient: 'TechConf Events Ltd — Goods In', line1: 'ExCeL London, One Western Gateway', city: 'London', postcode: 'E16 1XL', country: 'UK', notes: 'Deliver to loading bay B' },
  'po-2848': { id: 'da-2848', label: 'Head office', recipient: 'RetailCo UK — Merchandise Team', line1: '200 Deansgate', city: 'Manchester', postcode: 'M3 3WB', country: 'UK', notes: 'Contact Sarah Booth on arrival: 07700 900 123' },
  'po-2847': { id: 'da-2847', label: 'Distribution centre', recipient: 'RetailCo UK — DC Inbound', line1: 'Unit 12, Trafford Park Industrial Estate', line2: 'Trafford Park', city: 'Manchester', postcode: 'M17 1PQ', country: 'UK', notes: 'Book delivery slot 48 hrs in advance' },
  'po-2843': { id: 'da-2843', label: 'Venue goods in', recipient: 'SaaS Summit Ltd', line1: 'The Brewery, 52 Chiswell Street', city: 'London', postcode: 'EC1Y 4SD', country: 'UK' },
  'po-2842': { id: 'da-2842', label: 'Summit venue', recipient: 'SaaS Summit Ltd — Events Team', line1: 'The Brewery, 52 Chiswell Street', city: 'London', postcode: 'EC1Y 4SD', country: 'UK', notes: 'Deliver day before event — 18 Aug 2026' },
  'po-2838': { id: 'da-2838', label: 'Festival site', recipient: 'GreenFest CIC — Volunteer Coordinator', line1: 'Victoria Park', line2: 'Grove Road', city: 'London', postcode: 'E3 5TB', country: 'UK', notes: 'Eco-friendly packaging required' },
  'po-2835': { id: 'da-2835', label: 'NHS Trust HQ', recipient: 'HealthOrg NHS — Procurement', line1: 'Trust HQ, 330 Grays Inn Road', city: 'London', postcode: 'WC1X 8DA', country: 'UK', notes: 'NHS delivery compliance required — ref NHS-PO-2835' },
  'po-2831': { id: 'da-2831', label: 'Warehouse', recipient: 'SportsBrand Ltd — Inbound Logistics', line1: 'Unit 7, Magna Park', line2: 'Lutterworth', city: 'Lutterworth', postcode: 'LE17 4XN', country: 'UK', notes: 'Pallet delivery only — contact warehouse before dispatch' },
  'po-2821': { id: 'da-2821', label: 'Head office', recipient: 'FinanceCorp PLC — Office Manager', line1: '1 Canada Square', city: 'London', postcode: 'E14 5AB', country: 'UK', notes: 'Deliver to reception, Mon–Fri 09:00–17:00' },
  'po-2822': { id: 'da-2822', label: 'Regional office', recipient: 'FinanceCorp PLC — Manchester', line1: '3 Hardman Street', city: 'Manchester', postcode: 'M3 3HF', country: 'UK' },
};

const poStatuses = ['draft', 'sent', 'acknowledged', 'received', 'closed'];

const statusSteps = [
  { key: 'draft', label: 'Draft', icon: Clock },
  { key: 'sent', label: 'Sent', icon: Send },
  { key: 'acknowledged', label: 'Acknowledged', icon: CheckCircle2 },
  { key: 'received', label: 'Received', icon: Package },
  { key: 'closed', label: 'Closed', icon: XCircle },
];

// ─── Component ────────────────────────────────────────────────────────────────

export default function POLandingContent({ poId }: { poId: string }) {
  const po = allPOs.find(p => p.id === poId);
  const [currentStatus, setCurrentStatus] = useState(po?.status ?? 'draft');
  const [notes, setNotes] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  if (!po) {
    return (
      <div className="flex flex-col items-center justify-center py-24 space-y-4">
        <ShoppingCart size={40} style={{ color: 'var(--border)' }} />
        <p className="text-lg font-semibold" style={{ color: 'var(--foreground)' }}>Purchase order not found</p>
        <p className="text-sm" style={{ color: 'var(--slate)' }}>No PO with ID &quot;{poId}&quot; exists.</p>
        <Link href="/purchase-order-management" className="flex items-center gap-2 text-sm font-medium" style={{ color: 'var(--accent)' }}>
          <ArrowLeft size={14} /> Back to Purchase Orders
        </Link>
      </div>
    );
  }

  const lineItems = poLineItems[po.id] ?? defaultLineItems;
  const currentStepIndex = statusSteps.findIndex(s => s.key === currentStatus);

  const handleStatusChange = (status: string) => {
    setCurrentStatus(status);
    toast.success(`PO status updated to ${status}`);
  };

  const handleSaveNotes = () => {
    if (!notes.trim()) return;
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      toast.success('Notes saved');
    }, 800);
  };

  return (
    <div className="space-y-6">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 text-sm flex-wrap" style={{ color: 'var(--slate)' }}>
        <Link href="/purchase-order-management" className="hover:underline" style={{ color: 'var(--accent)' }}>Purchase Orders</Link>
        <ChevronRight size={14} />
        <Link href={`/jobs/${po.jobRef}`} className="hover:underline" style={{ color: 'var(--accent)' }}>{po.jobId}</Link>
        <ChevronRight size={14} />
        <span style={{ color: 'var(--foreground)' }}>{po.poNumber}</span>
      </div>

      {/* Header */}
      <div
        className="rounded-xl border p-6"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <div className="flex items-center gap-3 mb-1">
              <span className="text-xs font-mono font-semibold px-2 py-0.5 rounded" style={{ backgroundColor: 'var(--muted)', color: 'var(--slate)' }}>
                {po.poNumber}
              </span>
              <StatusBadge status={currentStatus as never} />
            </div>
            <h1 className="text-2xl font-semibold mt-2" style={{ color: 'var(--foreground)', letterSpacing: '-0.01em' }}>
              {po.supplier}
            </h1>
            <p className="text-sm mt-1" style={{ color: 'var(--slate)' }}>{po.jobName}</p>
          </div>
          <Link
            href="/purchase-order-management"
            className="flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md border transition-colors hover:bg-muted"
            style={{ borderColor: 'var(--border)', color: 'var(--slate)' }}
          >
            <ArrowLeft size={14} />
            Back to POs
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-5 pt-5 border-t" style={{ borderColor: 'var(--border)' }}>
          {[
            { label: 'Job ID', value: po.jobId, href: `/jobs/${po.jobRef}` },
            { label: 'Delivery ref', value: po.deliveryRef },
            { label: 'Created', value: po.createdDate },
            { label: 'PO total', value: po.total },
            { label: 'Linked SO', value: po.linkedSo, href: `/sales-orders/${po.linkedSoId}` },
            { label: 'AP invoice', value: po.linkedInvoice },
          ].map(f => (
            <div key={`pof-${f.label}`}>
              <p className="text-xs font-medium" style={{ color: 'var(--slate)' }}>{f.label}</p>
              {f.href && f.value !== '—' ? (
                <Link href={f.href} className="text-sm font-semibold mt-0.5 hover:underline block" style={{ color: 'var(--accent)' }}>
                  {f.value}
                </Link>
              ) : (
                <p className="text-sm font-semibold mt-0.5" style={{ color: 'var(--foreground)' }}>{f.value}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Document chain */}
      <div
        className="rounded-xl border p-5"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <h3 className="text-sm font-semibold mb-4" style={{ color: 'var(--foreground)' }}>Document chain</h3>
        <div className="flex items-center gap-3 flex-wrap">
          <Link href={`/jobs/${po.jobRef}`} className="text-center group">
            <p className="text-xs font-medium mb-1.5" style={{ color: 'var(--slate)' }}>Job</p>
            <span className="text-xs font-mono font-semibold px-2.5 py-1.5 rounded-md group-hover:underline block" style={{ backgroundColor: 'var(--muted)', color: 'var(--foreground)' }}>
              {po.jobId}
            </span>
          </Link>
          <ArrowRight size={14} style={{ color: 'var(--slate)' }} />
          <div className="text-center">
            <p className="text-xs font-medium mb-1.5" style={{ color: 'var(--slate)' }}>Purchase order</p>
            <span className="text-xs font-mono font-semibold px-2.5 py-1.5 rounded-md block" style={{ backgroundColor: 'var(--teal-light)', color: 'var(--accent)' }}>
              {po.poNumber}
            </span>
          </div>
          <ArrowRight size={14} style={{ color: 'var(--slate)' }} />
          <Link href={`/sales-orders/${po.linkedSoId}`} className="text-center group">
            <p className="text-xs font-medium mb-1.5" style={{ color: 'var(--slate)' }}>Sales order</p>
            <span className="text-xs font-mono font-semibold px-2.5 py-1.5 rounded-md group-hover:underline block" style={{ backgroundColor: 'var(--muted)', color: 'var(--foreground)' }}>
              {po.linkedSo}
            </span>
          </Link>
          {po.linkedInvoice !== '—' && (
            <>
              <ArrowRight size={14} style={{ color: 'var(--slate)' }} />
              <div className="text-center">
                <p className="text-xs font-medium mb-1.5" style={{ color: 'var(--slate)' }}>AP invoice</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs font-mono font-semibold px-2.5 py-1.5 rounded-md block" style={{ backgroundColor: 'var(--muted)', color: 'var(--foreground)' }}>
                    {po.linkedInvoice}
                  </span>
                  <ExternalLink size={11} style={{ color: 'var(--slate)' }} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Delivery address */}
      {(() => {
        const addr = deliveryAddressByPo[po.id];
        return (
          <div
            className="rounded-xl border overflow-hidden"
            style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
          >
            <div className="px-5 py-4 border-b flex items-center gap-2" style={{ borderColor: 'var(--border)' }}>
              <MapPin size={15} style={{ color: 'var(--accent)' }} />
              <h3 className="text-sm font-semibold" style={{ color: 'var(--foreground)' }}>Delivery address</h3>
            </div>
            {!addr ? (
              <div className="px-5 py-8 text-center">
                <MapPin size={28} className="mx-auto mb-2" style={{ color: 'var(--border)' }} />
                <p className="text-sm" style={{ color: 'var(--slate)' }}>No delivery address recorded for {po.poNumber}</p>
              </div>
            ) : (
              <div className="px-5 py-4 flex items-start gap-4">
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ backgroundColor: 'var(--teal-light)', color: 'var(--accent)' }}
                >
                  <MapPin size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--accent)' }}>{addr.label}</span>
                  <p className="text-sm font-medium mt-0.5" style={{ color: 'var(--foreground)' }}>{addr.recipient}</p>
                  <p className="text-sm mt-0.5" style={{ color: 'var(--slate)' }}>
                    {addr.line1}{addr.line2 ? `, ${addr.line2}` : ''}, {addr.city}, {addr.postcode}, {addr.country}
                  </p>
                  {addr.notes && (
                    <p className="text-xs mt-1.5 px-2.5 py-1.5 rounded-md" style={{ backgroundColor: 'var(--cloud)', color: 'var(--slate)' }}>
                      📋 {addr.notes}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })()}

      {/* Status progress */}
      <div
        className="rounded-xl border p-5"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <h3 className="text-sm font-semibold mb-4" style={{ color: 'var(--foreground)' }}>Status</h3>

        {/* Progress stepper */}
        <div className="flex items-center gap-0 mb-5 overflow-x-auto pb-1">
          {statusSteps.map((step, idx) => {
            const StepIcon = step.icon;
            const isDone = idx < currentStepIndex;
            const isCurrent = idx === currentStepIndex;
            return (
              <React.Fragment key={step.key}>
                <div className="flex flex-col items-center min-w-[72px]">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center mb-1.5 transition-all"
                    style={{
                      backgroundColor: isDone || isCurrent ? 'var(--accent)' : 'var(--muted)',
                      color: isDone || isCurrent ? 'white' : 'var(--slate)',
                    }}
                  >
                    <StepIcon size={14} />
                  </div>
                  <p className="text-xs font-medium text-center" style={{ color: isCurrent ? 'var(--accent)' : isDone ? 'var(--foreground)' : 'var(--slate)' }}>
                    {step.label}
                  </p>
                </div>
                {idx < statusSteps.length - 1 && (
                  <div
                    className="flex-1 h-0.5 mx-1 min-w-[16px]"
                    style={{ backgroundColor: idx < currentStepIndex ? 'var(--accent)' : 'var(--border)' }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Status buttons */}
        <div className="flex flex-wrap gap-2">
          {poStatuses.map(s => (
            <button
              key={`po-status-btn-${s}`}
              onClick={() => handleStatusChange(s)}
              className="px-3 py-1.5 text-xs font-medium rounded-md border transition-all"
              style={{
                backgroundColor: currentStatus === s ? 'var(--ink)' : 'var(--card)',
                color: currentStatus === s ? 'white' : 'var(--slate)',
                borderColor: currentStatus === s ? 'var(--ink)' : 'var(--border)',
              }}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Line items */}
      <div
        className="rounded-xl border overflow-hidden"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <div className="px-5 py-4 border-b" style={{ borderColor: 'var(--border)' }}>
          <h3 className="text-sm font-semibold" style={{ color: 'var(--foreground)' }}>Line items</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr style={{ backgroundColor: 'var(--cloud)', borderBottom: '1px solid var(--border)' }}>
                {['Description', 'Qty', 'Unit cost', 'Total'].map(h => (
                  <th key={`li-th-${h}`} className="text-left px-5 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--slate)', letterSpacing: '0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lineItems.map(li => (
                <tr key={li.id} className="border-b last:border-0" style={{ borderColor: 'var(--border)' }}>
                  <td className="px-5 py-3" style={{ color: 'var(--foreground)' }}>{li.description}</td>
                  <td className="px-5 py-3 tabular-nums" style={{ color: 'var(--slate)' }}>{li.qty}</td>
                  <td className="px-5 py-3 tabular-nums" style={{ color: 'var(--slate)' }}>{li.unitCost}</td>
                  <td className="px-5 py-3 tabular-nums font-semibold" style={{ color: 'var(--foreground)' }}>{li.total}</td>
                </tr>
              ))}
              <tr style={{ backgroundColor: 'var(--cloud)', borderTop: '1px solid var(--border)' }}>
                <td colSpan={3} className="px-5 py-3 font-semibold text-right" style={{ color: 'var(--foreground)' }}>PO total</td>
                <td className="px-5 py-3 tabular-nums font-bold text-lg" style={{ color: 'var(--foreground)' }}>{po.total}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Notes */}
      <div
        className="rounded-xl border p-5"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--foreground)' }}>Notes</h3>
        <textarea
          value={notes}
          onChange={e => setNotes(e.target.value)}
          placeholder="Add notes about this PO — supplier communications, delivery instructions, amendments…"
          rows={4}
          className="w-full px-3 py-2.5 text-sm rounded-md border outline-none resize-none"
          style={{ borderColor: 'var(--border)', backgroundColor: 'var(--cloud)', color: 'var(--foreground)' }}
        />
        <div className="flex items-center gap-3 mt-3">
          <button
            onClick={handleSaveNotes}
            disabled={isSaving || !notes.trim()}
            className="px-4 py-2 text-sm font-medium rounded-md text-white transition-all disabled:opacity-50"
            style={{ backgroundColor: 'var(--accent)' }}
          >
            {isSaving ? 'Saving…' : 'Save notes'}
          </button>
          <Link
            href={`/sales-orders/${po.linkedSoId}`}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md border transition-colors hover:bg-muted"
            style={{ borderColor: 'var(--border)', color: 'var(--slate)' }}
          >
            <ExternalLink size={14} />
            View linked SO
          </Link>
        </div>
      </div>
    </div>
  );
}
